import { inject as service } from '@ember/service';
import Controller, { inject as controller } from '@ember/controller';

export default class SettingsController extends Controller {
  @controller authenticated;

  @service auth;
  @service('crumbs') crumbsService;

  @service environment;
  @service masq;
  @service('releaseNotification') releaseNotification;

  account = null;

  // TODO: refactor environment-loading initialization logic, currently in "environments/:id" route
  get lastEnvironmentId() {
    return this.environment.lastEnvironmentId;
  }
}
